import { useEffect } from "react";

export default function useAuthSync() {
    useEffect(() => {
        const onStorage = (e) => {
            // e.key === null means localStorage.clear() was called
            if (e.key !== null && e.key !== "authToken") return;

            const loggedOut = e.key === null || !e.newValue;

            if (loggedOut) {
                // another tab logged out -> log out this tab too
                window.location.replace("/login");   // use your login route
            } else {
                // another tab logged in (maybe as a different user) -> reload,
                // so this tab never shows the old user
                window.location.reload();
            }
        };

        window.addEventListener("storage", onStorage);
        return () => window.removeEventListener("storage", onStorage);
    }, []);
}